<template>
  <div class="logo p" v-if="inview">
    <div class="question-mark" :style="'filter: blur(' + scrollPos + 'px)'">?</div>
    <img class="defaultImg" src="../assets/00_Fragezeichen.svg" alt="" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      scrollPos: 0,
      scrollIndex: 0,
      increment: 250
    };
  },
  mounted() {
    this.$root.$on("turnoff", this.turnOff);
    this.$root.$on("turnon", this.turnOn);
  },
  created() {
    window.addEventListener("scroll", this.changeQuestion);
  },
  destroyed() {
    window.removeEventListener("scroll", this.changeQuestion);
  },
  computed: {
    ...mapState(["site"]),
    inview() {
      return this.$store.state.inview;
    }
  },
  methods: {
    turnOff() {
      this.$store.state.inview = false;
    },
    turnOn() {
      this.$store.state.inview = true;
    },
    changeQuestion() {
      let max = window.innerHeight * 2
      let count = window.pageYOffset % max;
      let sensivity = 15;
      let half = max / 2;
      // let times = Math.floor(window.pageYOffset / max);
      let direction = 1;
      // if(times % 2) {
        // direction = 1;
      // } else {
        // direction = -1;
      // }
      if(count < half) {
        this.scrollPos = (count / sensivity) * direction;
      } else {
        this.scrollPos = ((max - count) / sensivity) * direction;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  display:flex;
  overflow:hidden;
  flex-direction:column;
  justify-content: center;
  align-items: center;
  font-size:42vw;
  z-index:90;
  .question-mark {
    position:relative;
    width:100%;
    text-align:center;
    &:after {
      content:"";
      position:absolute;
      bottom:0;
      left:0;
      width:100%;
      height:16vw;
      background:var(--bg);
    }
  }
  @media only screen and (max-width:768px) {
    position:absolute;
    width:100%;
    z-index:10;
    opacity:1;
    top:calc(0 * var(--lh));
    font-size:60vw;
    
    .question-mark {
      transform:scale(2);
      &:after {
        height:25vw;
      }
    }
  }
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50.25%, -48%);
    width: 100%;
    height: 100%;
    padding: calc(0.4 * var(--lh));
    object-fit: contain;
    display: none;
    &.active,
    &.defaultImg {
      display: block;
    }
    @media only screen and (max-width:768px) {
      transform: translate(-50.25%, -50%);
      width:140%;
      padding:calc(0 * var(--lh));
    }
  }
}
</style>
